import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        planningGroup: '=',
        context: '='
    },
    template: `
    <form class="form" ng-submit="vm.save()">
        <form-wrapper form="vm.form">
            <alert-error ng-if="vm.getSaveErrors().length">
                <span
                    ng-repeat="error in vm.getSaveErrors() track by $index"
                    style="display: block"
                    ng-bind-html="error"
                ></span>
            </alert-error>
            <form-row error="vm.form.errors.type">
                <label class="label">{{ 'planningGroup.Adding employees to automated group' | translate }} *</label>
                <div class="items">
                    <ul class="checkboxes">
                        <li ng-repeat="(key,value) in vm.AUTOMATED_PLANNING_GROUP_TYPE_ENUM.LABELS">
                            <label>
                                <input
                                    type="radio"
                                    ng-model="vm.form.model.type"
                                    ng-click="vm.toggleFormWorkingSince(); vm.toggleFormTargetType()"
                                    name="planningGroupType"
                                    ng-value="key"
                                    ng-readOnly="vm.isTypeReadOnly"
                                    ng-disabled="vm.isTypeReadOnly">
                                {{ value }}
                                <small ng-if="key===vm.AUTOMATED_PLANNING_GROUP_TYPE_ENUM.KEYS.AUTOMATIC">
                                    {{ 'planningGroup.Targeted employees are automatically added to group' | translate }}
                                </small>
                            </label>
                        </li>
                    </ul>
                    <form-row-error></form-row-error>
                </div>
            </form-row>
            <div ng-if="vm.form.model.type === vm.AUTOMATED_PLANNING_GROUP_TYPE_ENUM.KEYS.AUTOMATIC" class="well">
                <label class="heading01" style="cursor: pointer; width: fit-content;">
                    <label class="switch01">
                        <input type="checkbox" ng-click="vm.toggleFormWorkingSince()" ng-model="vm.form.model.onlyForNewEmployees" name="switch" id="onlyForNewEmployees">
                        <span>{{ 'general.Yes' | translate }}</span>
                    </label>
                    <h2 class="h3">{{ 'planningGroup.Only for new employees' | translate }}<br/><small>{{ "planningGroup.Based on field 'Working since' value" | translate }}</small></h2>
                </label>
                <div class="row" ng-if="vm.form.model.onlyForNewEmployees">
                    <label class="label">{{ "planningGroup.Consider a user 'New' if working since is after the:" | translate }}</label>
                    <div class="items">
                        <datepicker-api
                            ng-id="'maxWorkingSince'"
                            ng-model="vm.form.model.maxWorkingSince"
                            ng-disabled="!vm.form.model.onlyForNewEmployees"
                        />
                        <p class="desc error" ng-if="vm.form.errors.maxWorkingSince">{{ vm.form.errors.maxWorkingSince }}</p>
                    </div>
                </div>
            </div>
            <div ng-if="vm.form.model.type === vm.AUTOMATED_PLANNING_GROUP_TYPE_ENUM.KEYS.AUTOMATIC" class="well">
                <label class="heading01" for="onlyForDirectManagers" style="cursor: pointer; width: fit-content;">
                    <label class="switch01">
                        <input type="checkbox" ng-model="vm.form.model.onlyForDirectManagers" name="switch" id="onlyForDirectManagers">
                        <span>{{ 'general.Yes' | translate }}</span>
                    </label>
                    <h2 class="h3">{{ 'planningGroup.Only for direct managers' | translate }}</h2>
                </label>
            </div>
            <div ng-if="vm.form.model.type === vm.AUTOMATED_PLANNING_GROUP_TYPE_ENUM.KEYS.AUTOMATIC && vm.canUseSkillProficiencyRule" class="well">
                <label class="heading01" for="enableSkillProficiencyRule" style="cursor: pointer; width: fit-content;">
                    <label class="switch01">
                        <input type="checkbox" ng-model="vm.form.model.enableSkillProficiencyRule" name="switch" id="enableSkillProficiencyRule">
                        <span>{{ 'general.Yes' | translate }}</span>
                    </label>
                    <h2 class="h3">{{ 'planningGroup.Skill proficiency rule' | translate }}<br/><small>{{ "planningGroup.Include users with specific skill proficiencies" | translate }}</small></h2>
                </label>
                <div ng-if="vm.form.model.enableSkillProficiencyRule">
                    <div class="rowgroup inline">
                        <div class="row row-wide" ng-class="{'has-error': vm.skillSelectionError}">
                            <label class="label w100p">{{ 'planningGroup.Select skill' | translate }} *</label>
                            <div class="items w100p">
                                <select class="form-control wide"
                                    ng-model="vm.skillSelection.selectedSkillId"
                                    ng-options="skill.id as skill.searchName for skill in vm.availableSkills"
                                    ng-change="vm.onSkillSelectChange()">
                                    <option value="">{{ 'planningGroup.Choose skill' | translate }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row row-wide" ng-class="{'has-error': vm.skillSelectionError}">
                            <label class="label w100p">{{ 'planningGroup.Comparison operator' | translate }} *</label>
                            <div class="items w100p">
                                <select class="form-control wide" ng-model="vm.skillSelection.operator"
                                    ng-options="op.value as op.label for op in vm.comparisonOperators">
                                </select>
                            </div>
                        </div>
                        <div class="row row-wide" ng-class="{'has-error': vm.skillSelectionError}">
                            <label class="label w100p">{{ 'planningGroup.Proficiency level' | translate }} *</label>
                            <div class="items w100p">
                                <select class="form-control wide"
                                    ng-model="vm.skillSelection.proficiencyId"
                                    ng-options="p.id as (p.points + ' - ' + vm.getProficiencyValue(p, vm.skillSelection.selectedSkill)) for p in vm.selectedSkillProficiencies">
                                    <option value="">{{ 'planningGroup.Choose level' | translate }}</option>
                                </select>
                            </div>
                        </div>
                        <ul class="actions01">
                            <li><a class="btn main" ng-click="vm.addSkillRequirement()">{{ 'planningGroup.Add skill' | translate }}</a></li>
                        </ul>
                    </div>
                    <div class="row has-error" ng-if="vm.skillSelectionError">
                        <p class="desc error">{{ vm.skillSelectionError }}</p>
                    </div>
                    <h3>{{ 'planningGroup.Skill Matching Logic' | translate }}</h3>
                    <ul class="checkboxes">
                        <li>
                            <label>
                                <input type="radio" name="skillMatchLogic" ng-model="vm.form.model.skillMatchLogic" value="and">
                                {{ 'planningGroup.Match ALL skills (AND)' | translate }}
                            </label>
                            <p class="desc">{{ 'planningGroup.Users must have all selected skills at the specified proficiency levels' | translate }}</p>
                        </li>
                        <li>
                            <label>
                                <input type="radio" name="skillMatchLogic" ng-model="vm.form.model.skillMatchLogic" value="or">
                                {{ 'planningGroup.Match ANY skill (OR)' | translate }}
                            </label>
                            <p class="desc">{{ 'planningGroup.Users need at least one of the selected skills at the specified proficiency level' | translate }}</p>
                        </li>
                    </ul>
                    <h3>{{ 'planningGroup.Required skills and proficiencies' | translate }} <span class="tag">{{ vm.getTranslatedMatchLogic(vm.form.model.skillMatchLogic) }}</span></h3>
                    <ul class="tags-list">
                        <li ng-repeat="requirement in vm.form.model.skillRequirements"
                            ng-attr-data-after="{{ !$last ? vm.getTranslatedMatchLogic(vm.form.model.skillMatchLogic) : '' }}"
                            ng-style="vm.isDuplicateRequirement(requirement) ? {'outline': '2px solid #e74c3c', 'outline-offset': '2px'} : {}">
                            <span style="display: flex; align-items: center; max-width: 100%;">
                                <span style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" title="{{ requirement.skillName }}">{{ requirement.skillName }}</span>
                                <span style="white-space: nowrap; margin-left: 4px;">{{ requirement.operator }} {{ requirement.proficiencyName }}</span>
                                <button class="ico-delete" ng-click="vm.removeSkillRequirement($index)"><span>{{ 'general.Remove' | translate }}</span></button>
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="well" ng-if="vm.form.model.type === vm.AUTOMATED_PLANNING_GROUP_TYPE_ENUM.KEYS.AUTOMATIC">
                <label class="heading01" for="enableCourseCompletionRule" style="cursor: pointer;">
                    <label class="switch01">
                        <input type="checkbox" ng-model="vm.form.model.enableCourseCompletionRule" name="switch" id="enableCourseCompletionRule">
                        <span>{{ 'general.Yes' | translate }}</span>
                    </label>
                    <h2 class="h3">{{ 'planningGroup.Course completion rule' | translate }}
                        <br/>
                        <small>{{ 'planningGroup.Include users who have completed specific courses' | translate }}</small>
                    </h2>
                </label>
                <div ng-if="vm.form.model.enableCourseCompletionRule">
                    <div class="row row-size07">
                        <label class="label">{{ 'planningGroup.Search and add courses' | translate }}</label>
                        <div class="items w100p">
                            <div class="multiselect-parent btn-group btn-group-justified course-lazy-multiselect"
                                style="position: relative; padding-top: 10px">
                                <button type="button" class="btn btn-default dropdown-toggle"
                                    ng-click="vm.toggleCourseDropdown()"
                                    style="text-align: left; display: flex; justify-content: space-between; align-items: center;">
                                    <span ng-if="vm.form.model.courseRequirements.length === 0">
                                        {{ 'planningGroup.Select courses' | translate }}
                                    </span>
                                    <span ng-if="vm.form.model.courseRequirements.length > 0">
                                        {{ vm.form.model.courseRequirements.length }}
                                        {{ 'planningGroup.courses selected' | translate }}
                                    </span>
                                    <span class="caret"></span>
                                </button>
                                <ul ng-if="vm.courseDropdownOpen" class="dropdown-menu dropdown-menu-form"
                                    style="display: block; width: 100%; max-height: 300px; overflow-y: auto; padding: 0;"
                                    id="courseDropdownList">
                                    <li style="padding: 6px 10px; position: sticky; top: 0; background: #fff; z-index: 1;">
                                        <input type="text" class="form-control input-sm"
                                            placeholder="{{ 'planningGroup.Search' | translate }}"
                                            ng-model="vm.courseSearchText"
                                            ng-change="vm.onCourseSearchChange()"
                                            ng-click="$event.stopPropagation()">
                                    </li>
                                    <li ng-repeat="option in vm.courseDropdownOptions track by option.id"
                                        style="padding: 0;">
                                        <a ng-click="vm.toggleCourseOption(option); $event.stopPropagation();"
                                            style="cursor: pointer; padding: 4px 10px; display: flex; align-items: center;">
                                            <input type="checkbox"
                                                ng-checked="vm.isCourseSelected(option.id)"
                                                style="margin-right: 6px; pointer-events: none;">
                                            <span>{{ option.label }}</span>
                                        </a>
                                    </li>
                                    <li ng-if="vm.courseDropdownLoading" style="padding: 8px; text-align: center;">
                                        <span>{{ 'general.Loading' | translate }}...</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div ng-if="vm.form.model.courseRequirements.length > 0">
                        <h3>{{ 'planningGroup.Course Matching Logic' | translate }}</h3>
                        <ul class="checkboxes">
                            <li>
                                <label>
                                    <input type="radio" name="courseMatchLogic" ng-model="vm.form.model.courseMatchLogic" value="and">
                                    {{ 'planningGroup.Match ALL courses (AND)' | translate }}
                                </label>
                                <p class="desc">{{ 'planningGroup.Users must have completed all selected courses' | translate }}</p>
                            </li>
                            <li>
                                <label>
                                    <input type="radio" name="courseMatchLogic" ng-model="vm.form.model.courseMatchLogic" value="or">
                                    {{ 'planningGroup.Match ANY course (OR)' | translate }}
                                </label>
                                <p class="desc">{{ 'planningGroup.Users need to have completed at least one of the selected courses' | translate }}</p>
                            </li>
                        </ul>
                    </div>
                    <div ng-if="vm.form.model.courseRequirements.length > 0">
                        <h3>{{ 'planningGroup.Required courses' | translate }}
                            <span class="tag">{{ vm.getTranslatedMatchLogic(vm.form.model.courseMatchLogic) }}</span>
                        </h3>
                        <ul class="tags-list">
                            <li ng-repeat="item in vm.form.model.courseRequirements"
                                ng-attr-data-after="{{ !$last ? vm.getTranslatedMatchLogic(vm.form.model.courseMatchLogic) : '' }}">
                                <span style="display: flex; align-items: center; max-width: 100%;">
                                    <span style="max-width: 400px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" title="{{ item.label }}">{{ item.label }}</span>
                                    <button type="button" class="ico-delete" ng-click="vm.removeCourseRequirement(item.id)">
                                        <span>Remove</span>
                                    </button>
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <form-row
                ng-if="vm.form.model.type === vm.AUTOMATED_PLANNING_GROUP_TYPE_ENUM.KEYS.AUTOMATIC"
                error="vm.form.errors.targetType || vm.form.errors.targets"
            >
                <label class="label">
                    {{ "planningGroup.Automated planning group targets" | translate }} *
                </label>
                <div class="items">
                    <ul class="checkboxes">
                        <li ng-repeat="(value, label) in vm.AUTOMATED_PLANNING_GROUP_TARGET_TYPE_ENUM.LABELS">
                            <label>
                                <input
                                  ng-disabled="vm.form.model.type === vm.AUTOMATED_PLANNING_GROUP_TYPE_ENUM.KEYS.MANUAL
                                    && value === vm.AUTOMATED_PLANNING_GROUP_TARGET_TYPE_ENUM.KEYS.CUSTOM_TARGETS"
                                  type="radio"
                                  value="{{ value }}"
                                  ng-model="vm.form.model.targetType"
                                > {{ label }}
                            </label>
                        </li>
                    </ul>
                    <form-row-error></form-row-error>
                </div>
            </form-row>
        </form-wrapper>
    </form>
    <courses-courses-edit-occurrence-automated-planning-group-steps-targets-list
        ng-if="vm.form.model.type === vm.AUTOMATED_PLANNING_GROUP_TYPE_ENUM.KEYS.AUTOMATIC
            && vm.form.model.targetType === vm.AUTOMATED_PLANNING_GROUP_TARGET_TYPE_ENUM.KEYS.CUSTOM_TARGETS"
        planning-group="vm.planningGroup"
        form="vm.form"
        is-read-only="vm.isTypeReadOnly"
        on-reload="vm.onPlanningGroupReload()"
    />
    <courses-courses-edit-occurrence-automated-planning-group-footer
        planning-group="vm.planningGroup"
        form="vm.form"
        tab="'targets'"
        context="vm.context"
    />
    `
})
export default class {
    constructor ($scope, $filter, $timeout, $document, PrivilegeService, TokenService, SiteService,
                 AutomatedPlanningGroupResource, FormFactory, AUTOMATED_PLANNING_GROUP_TYPE_ENUM,
                 AUTOMATED_PLANNING_GROUP_STATUS_ENUM, AUTOMATED_PLANNING_GROUP_INTERVAL_TYPE_ENUM,
                 AUTOMATED_PLANNING_GROUP_MAX_WORKING_SINCE_ENUM, AUTOMATED_PLANNING_GROUP_TARGET_TYPE_ENUM,
                 CalendarService, SkillResource, ProficiencyResource, CourseResource, I18nService) {
        this.$scope = $scope;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$document = $document;
        this.FormFactory = FormFactory;
        this.PrivilegeService = PrivilegeService;
        this.TokenService = TokenService;
        this.SiteService = SiteService;
        this.AutomatedPlanningGroupResource = AutomatedPlanningGroupResource;
        this.AUTOMATED_PLANNING_GROUP_TYPE_ENUM = AUTOMATED_PLANNING_GROUP_TYPE_ENUM;
        this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM = AUTOMATED_PLANNING_GROUP_STATUS_ENUM;
        this.AUTOMATED_PLANNING_GROUP_INTERVAL_TYPE_ENUM = AUTOMATED_PLANNING_GROUP_INTERVAL_TYPE_ENUM;
        this.AUTOMATED_PLANNING_GROUP_MAX_WORKING_SINCE_ENUM = AUTOMATED_PLANNING_GROUP_MAX_WORKING_SINCE_ENUM;
        this.AUTOMATED_PLANNING_GROUP_TARGET_TYPE_ENUM = AUTOMATED_PLANNING_GROUP_TARGET_TYPE_ENUM;
        this.CalendarService = CalendarService;
        this.SkillResource = SkillResource;
        this.ProficiencyResource = ProficiencyResource;
        this.CourseResource = CourseResource;
        this.I18nService = I18nService;

        // Initialize skill proficiency data structures
        this.skillSelection = {
            selectedSkill: null,
            selectedSkillId: null,
            operator: '=',
            proficiencyId: null
        };
        this.allSkills = [];
        this.availableSkills = [];
        this.selectedSkillProficiencies = [];
        this.skillSelectionError = null;
        this.duplicateRequirement = null;

        // Comparison operators with translated labels
        this.comparisonOperators = [
            { value: '=', label: $filter('translate')('planningGroup.Equal to') },
            { value: '<', label: $filter('translate')('planningGroup.Smaller than') },
            { value: '>', label: $filter('translate')('planningGroup.Larger than') },
            { value: '<=', label: $filter('translate')('planningGroup.Equal or smaller') },
            { value: '>=', label: $filter('translate')('planningGroup.Equal or larger') }
        ];

        $scope.$on('planning-group:update', (event, updatedGroup) => {
            this.planningGroup = updatedGroup;
            this.$onInit();
        });

        this.allCourses = [];
        this.courseDropdownOpen = false;
        this.courseDropdownOptions = [];
        this.courseDropdownLoading = false;
        this.courseSearchText = '';
        this.courseSearchDebounce = null;
        this.coursePage = 1;
        this.coursePageSize = 30;
        this.courseHasMore = true;

        this.$document.on('click', this.closeCourseDropdownHandler = (event) => {
            const dropdown = document.querySelector('.course-lazy-multiselect');
            if (dropdown && !dropdown.contains(event.target)) {
                this.$scope.$apply(() => {
                    this.courseDropdownOpen = false;
                });
            }
        });

        $scope.$on('$destroy', () => {
            this.$document.off('click', this.closeCourseDropdownHandler);
        });
    }

    $onInit () {
        this.form = this.FormFactory.createFromResource(
            this.planningGroup,
            {
                expand: 'planningGroupUsers,course,planningGroupTargetsWithValue.user.drlsWithValue,'
                    + 'planningGroupTargetsWithValue.courseTarget.employee.drlsWithValue,'
                    + 'targetRulesets.conditions.course.activeI18n,targetRulesets.conditions'
            }
        );
        this.form.model.targets = this.planningGroup.planningGroupTargetsWithValue;

        // Ensure these properties exist on the model immediately
        this.form.model.courseRequirements = this.form.model.courseRequirements || [];
        this.form.model.skillRequirements = this.form.model.skillRequirements || [];

        if (!this.form.model.type) {
            this.form.model.type = this.AUTOMATED_PLANNING_GROUP_TYPE_ENUM.KEYS.AUTOMATIC;
        }

        if (!this.form.model.intervalType) {
            this.form.model.intervalType = this.AUTOMATED_PLANNING_GROUP_INTERVAL_TYPE_ENUM.KEYS.DAY;
        }

        this.isReadOnly = this.planningGroup.status !== this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM.KEYS.NOT_STARTED
            || !this.PrivilegeService.canManageAutomatedPlanningGroups();

        this.isTypeReadOnly = this.planningGroup.status === this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM.KEYS.CANCELLED
            || !this.PrivilegeService.canManageAutomatedPlanningGroups();

        this.canUseSkillProficiencyRule = this.TokenService.isSkillsModuleEnabled()
            && (this.PrivilegeService.canManageSkills() || this.PrivilegeService.canManageUserSkills());

        if (this.form.model.maxWorkingSince) {
            this.form.model.onlyForNewEmployees = true;
        }

        const hasSiteIds = Array.isArray(this.form.model.siteIds) && this.form.model.siteIds.length > 0;
        if (!this.form.model.id && !hasSiteIds && this.TokenService.isTrainingCompany()) {
            this.form.model.excludeExternalSites = true;
        }

        if (this.form.model.onlyForDirectManagers) {
            this.form.model.onlyForDirectManagers = true;
        }
        if (this.form.model.onlyForNewEmployees && this.form.model.maxWorkingSince === null) {
            this.form.model.maxWorkingSince = this.CalendarService.getDateInRequestApiFormat(new Date());
        }

        this.loadExistingTargetRulesets();
        this.loadCourses();

        // Hook into form save to transform requirements to targetRulesets
        const originalSave = this.form.save.bind(this.form);
        this.form.save = () => {
            // Check if feature flags were actually on during save
            const saveEnableSkill = this.form.model.enableSkillProficiencyRule;
            const saveEnableCourse = this.form.model.enableCourseCompletionRule;

            this.transformSkillRequirementsToTargetRulesets();
            this.transformCourseRequirementsToTargetRulesets();

            // Restore flags for UI consistency after save
            this.form.model.enableSkillProficiencyRule = saveEnableSkill;
            this.form.model.enableCourseCompletionRule = saveEnableCourse;

            return originalSave();
        };

        if (this.canUseSkillProficiencyRule) {
            this.loadSkills();
        }
    }

    /**
     * Every message a refused save produced that this step can show, one alert with a line each
     *
     * Every step carries the same footer, so a save started here can be refused for something this step
     * has no field for. Refusals about the group's sites or people are not listed: the footer takes
     * those to the general tab, the only place they can be fixed.
     *
     * @returns {string[]}
     */
    getSaveErrors () {
        return [
            this.form.errors.courseVersionId,
            this.form.errors.trainings
        ].filter(Boolean);
    }

    toggleFormWorkingSince () {
        if (this.form.model.type !== this.AUTOMATED_PLANNING_GROUP_TYPE_ENUM.KEYS.AUTOMATIC) {
            this.form.model.maxWorkingSince = null;
            this.form.model.onlyForNewEmployees = false;
        }
        else if (!this.form.model.onlyForNewEmployees) {
            this.form.model.maxWorkingSince = null;
        }
        if (this.form.model.onlyForNewEmployees && this.form.model.maxWorkingSince === null) {
            this.form.model.maxWorkingSince = this.CalendarService.getDateInRequestApiFormat(new Date());
        }
    }

    toggleFormTargetType () {
        if (this.form.model.type === this.AUTOMATED_PLANNING_GROUP_TYPE_ENUM.KEYS.MANUAL) {
            this.form.model.targetType = this.AUTOMATED_PLANNING_GROUP_TARGET_TYPE_ENUM.KEYS.ALL_COURSE_TARGETS;
        }
    }

    loadCourses () {
        this.coursePage = 1;
        this.courseHasMore = true;
        this.courseDropdownOptions = [];
        this.fetchCourses();
    }

    fetchCourses (append = false) {
        if (this.courseDropdownLoading) {
            return;
        }
        this.courseDropdownLoading = true;

        const params = {
            pageSize: this.coursePageSize,
            page: this.coursePage,
            expand: 'activeI18n'
        };

        if (this.courseSearchText && this.courseSearchText.trim().length > 0) {
            params.name = this.courseSearchText.trim();
        }

        this.CourseResource.query(params).$promise.then(response => {
            const currentCourseId = this.planningGroup.course_id || this.planningGroup.courseId;
            const rawItems = response.items || response || [];
            const items = (response || []).filter(course => course.id !== currentCourseId);
            const mapped = items.map(course => ({
                id: course.id,
                label: (course.activeI18n && course.activeI18n.name) || course.title || course.name
            }));

            if (append) {
                this.courseDropdownOptions = this.courseDropdownOptions.concat(mapped);
            }
            else {
                this.courseDropdownOptions = mapped;
            }

            this.courseHasMore = rawItems.length >= this.coursePageSize;

            // Sync labels for existing requirements if they were missing
            if (this.form.model.courseRequirements) {
                this.form.model.courseRequirements.forEach(req => {
                    if (!req.label) {
                        const match = this.courseDropdownOptions.find(c => c.id === req.id);
                        if (match) {
                            req.label = match.label;
                        }
                    }
                });
            }

            this.courseDropdownLoading = false;
            this.bindCourseDropdownScroll();
        }).catch(() => {
            this.courseDropdownLoading = false;
        });
    }

    // Replace bindCourseDropdownScroll with this:
    bindCourseDropdownScroll () {
        this.$timeout(() => {
            const listElement = document.getElementById('courseDropdownList');
            if (!listElement || listElement._lazyScrollBound) return;

            listElement._lazyScrollBound = true;
            listElement.addEventListener('scroll', () => {
                const distanceFromBottom = listElement.scrollHeight - listElement.scrollTop - listElement.clientHeight;
                if (distanceFromBottom < 50 && this.courseHasMore && !this.courseDropdownLoading) {
                    this.$scope.$apply(() => {
                        this.coursePage++;
                    });
                    this.fetchCourses(true);
                }
            });
        }, 100); // slight delay to ensure ng-if has rendered the element
    }

    toggleCourseDropdown () {
        this.courseDropdownOpen = !this.courseDropdownOpen;
        if (this.courseDropdownOpen) {
            this.$timeout(() => {
                const listElement = document.getElementById('courseDropdownList');
                if (listElement) {
                    listElement._lazyScrollBound = false;
                }
                this.bindCourseDropdownScroll();
            }, 0);
        }
    }

    onCourseSearchChange () {
        if (this.courseSearchDebounce) {
            this.$timeout.cancel(this.courseSearchDebounce);
        }
        this.courseSearchDebounce = this.$timeout(() => {
            this.coursePage = 1;
            this.courseHasMore = true;
            this.courseDropdownOptions = [];
            this.resetCourseDropdownScroll();
            this.fetchCourses();
        }, 300);
    }

    resetCourseDropdownScroll () {
        const listElement = document.getElementById('courseDropdownList');
        if (listElement) {
            listElement._lazyScrollBound = false;
            listElement.scrollTop = 0;
        }
    }

    updateCourseMultiselectModel () {
        if (!this.form.model.courseRequirements) {
            return;
        }

        if (this.form.model.courseRequirements.length > 0) {
            this.form.model.enableCourseCompletionRule = true;
        }
    }

    toggleCourseOption (option) {
        if (!this.form.model.courseRequirements) {
            this.form.model.courseRequirements = [];
        }

        const existingIndex = this.form.model.courseRequirements.findIndex(r => r.id === option.id);
        if (existingIndex >= 0) {
            this.form.model.courseRequirements.splice(existingIndex, 1);
        }
        else {
            this.form.model.courseRequirements.push({
                id: option.id,
                label: option.label
            });
        }
    }

    isCourseSelected (courseId) {
        return this.form.model.courseRequirements
            && this.form.model.courseRequirements.some(r => r.id === courseId);
    }

    removeCourseRequirement (courseId) {
        this.form.model.courseRequirements = this.form.model.courseRequirements.filter(r => r.id !== courseId);
    }

    loadSkills () {
        // Load skills with their i18n names and proficiencies
        this.SkillResource.query({
            expand: 'i18ns,scale.scaleI18ns,scale.proficiencies.skillProficiencyI18n',
            is_active: 1,
            pageSize: 0
        }).$promise
            .then(response => {
                const allSkills = response.items || response || [];

                // Filter proficiency i18ns by enabled scale languages
                allSkills.forEach(skill => {
                    this.filterProficiencyI18nsByEnabledLanguages(skill);
                });

                // Store all skills and add translated searchName property (truncated for dropdown)
                this.allSkills = allSkills.map(skill => {
                    const fullName = this.getSkillName(skill);
                    skill.fullName = fullName;
                    skill.searchName = this.truncateText(fullName, 50);
                    return skill;
                });
                // Show all skills in dropdown (including already selected ones)
                this.availableSkills = this.allSkills;
            })
            .catch(error => {
                console.error('Error loading skills:', error);
                this.allSkills = [];
                this.availableSkills = [];
            });
    }

    onSkillSelectChange () {
        if (!this.skillSelection.selectedSkillId) {
            this.selectedSkillProficiencies = [];
            this.skillSelection.proficiencyId = null;
            this.skillSelection.selectedSkill = null;
            return;
        }

        // Find the full skill object from the ID
        const skill = this.allSkills.find(s => s.id === this.skillSelection.selectedSkillId);
        this.skillSelection.selectedSkill = skill;

        if (skill && skill.scale && skill.scale.proficiencies) {
            this.selectedSkillProficiencies = skill.scale.proficiencies;
            // Auto-select first proficiency if available
            if (this.selectedSkillProficiencies.length > 0) {
                this.skillSelection.proficiencyId = this.selectedSkillProficiencies[0].id;
            }
        }
        else {
            this.selectedSkillProficiencies = [];
            this.skillSelection.proficiencyId = null;
        }
    }

    addSkillRequirement () {
        this.skillSelectionError = null;
        this.duplicateRequirement = null;

        if (!this.skillSelection.selectedSkill || !this.skillSelection.proficiencyId) {
            return;
        }

        const skill = this.skillSelection.selectedSkill;
        const proficiency = this.selectedSkillProficiencies.find(p => p.id === this.skillSelection.proficiencyId);

        if (!skill || !proficiency) {
            return;
        }

        // Check for duplicate (same skill, operator, and proficiency)
        const duplicateReq = this.form.model.skillRequirements.find(req =>
            req.skillId === skill.id &&
            req.operator === this.skillSelection.operator &&
            req.proficiencyId === proficiency.id
        );

        if (duplicateReq) {
            this.skillSelectionError = this.$filter('translate')('planningGroup.Skill requirement already exists');
            this.duplicateRequirement = duplicateReq;
            return;
        }

        const requirement = {
            skillId: skill.id,
            skillName: this.getSkillName(skill),
            operator: this.skillSelection.operator,
            proficiencyId: proficiency.id,
            proficiencyName: this.getProficiencyValue(proficiency, skill),
            proficiencyPoints: proficiency.points
        };

        // Add new requirement
        this.form.model.skillRequirements.push(requirement);

        // Reset selection
        this.skillSelection.selectedSkill = null;
        this.skillSelection.selectedSkillId = null;
        this.skillSelection.operator = '=';
        this.skillSelection.proficiencyId = null;
        this.selectedSkillProficiencies = [];
    }

    isDuplicateRequirement (requirement) {
        return this.duplicateRequirement &&
            requirement.skillId === this.duplicateRequirement.skillId &&
            requirement.operator === this.duplicateRequirement.operator &&
            requirement.proficiencyId === this.duplicateRequirement.proficiencyId;
    }

    removeSkillRequirement (index) {
        this.form.model.skillRequirements.splice(index, 1);
        this.duplicateRequirement = null;
        this.skillSelectionError = null;
    }

    getSkillName (skill) {
        if (!skill || !skill.i18ns) {
            return '';
        }

        const i18n = this.I18nService.getPreferredI18n(skill.i18ns);

        if (!i18n || !i18n.name) {
            return 'no translation';
        }
        return i18n.name;
    }

    truncateText (text, maxLength) {
        if (!text || text.length <= maxLength) {
            return text;
        }
        return `${text.substring(0, maxLength)}...`;
    }

    getProficiencyValue (proficiency, skill) {
        if (!proficiency || !proficiency.skillProficiencyI18n) {
            return '';
        }

        // Use the same language as the skill to keep translations aligned
        if (skill && skill.i18ns) {
            const skillI18n = this.I18nService.getPreferredI18n(skill.i18ns);
            const skillLanguage = skillI18n && skillI18n.language;

            if (skillLanguage && proficiency.skillProficiencyI18n[skillLanguage]) {
                return proficiency.skillProficiencyI18n[skillLanguage].value || 'no translation';
            }
        }

        // Fallback to existing logic
        const i18n = this.I18nService.getPreferredI18n(proficiency.skillProficiencyI18n);

        if (!i18n || !i18n.value) {
            return 'no translation';
        }
        return i18n.value;
    }

    filterProficiencyI18nsByEnabledLanguages (skill) {
        if (!skill || !skill.scale) return;

        // Get enabled languages from the scale
        const enabledLanguages = {};
        if (skill.scale.scaleI18ns) {
            Object.keys(skill.scale.scaleI18ns).forEach(lang => {
                const i18n = skill.scale.scaleI18ns[lang];
                if (i18n && i18n.isEnabled) {
                    enabledLanguages[lang] = true;
                }
            });
        }

        // Filter proficiency translations to only include enabled languages
        const proficiencies = skill.scale.proficiencies || [];
        proficiencies.forEach(p => {
            if (!p.skillProficiencyI18n) return;

            const filteredI18ns = {};
            Object.keys(p.skillProficiencyI18n).forEach(lang => {
                if (enabledLanguages[lang]) {
                    filteredI18ns[lang] = p.skillProficiencyI18n[lang];
                }
            });
            p.skillProficiencyI18n = filteredI18ns;
        });
    }

    getTranslatedMatchLogic (logic) {
        if (logic === 'and') {
            return this.$filter('translate')('planningGroup.AND');
        }
        else if (logic === 'or') {
            return this.$filter('translate')('planningGroup.OR');
        }
        return logic;
    }

    loadExistingTargetRulesets () {
        // Check if we have existing targetRulesets data from the database
        if (this.planningGroup.targetRulesets && this.planningGroup.targetRulesets.length > 0) {
            this.form.model.courseRequirements = [];
            this.form.model.skillRequirements = [];

            // Initialize defaults before processing rulesets
            this.form.model.enableSkillProficiencyRule = false;
            this.form.model.skillMatchLogic = 'and';
            this.form.model.enableCourseCompletionRule = false;
            this.form.model.courseMatchLogic = 'and';

            this.planningGroup.targetRulesets.forEach(ruleset => {
                if ((ruleset.ruleset_type || ruleset.rulesetType) === 'skill_proficiency') {
                    // Enable the skill proficiency rule feature
                    this.form.model.enableSkillProficiencyRule = true;

                    // Set the match logic
                    this.form.model.skillMatchLogic = ruleset.match_logic || ruleset.matchLogic || 'and';

                    // Transform conditions back to skillRequirements for the UI
                    if (ruleset.conditions && ruleset.conditions.length > 0) {
                        this.loadSkillsForExistingRequirements(ruleset.conditions);
                    }
                }
                else if ((ruleset.ruleset_type || ruleset.rulesetType) === 'course_completion') {
                    // Enable the course completion rule feature
                    this.form.model.enableCourseCompletionRule = true;

                    // Set the match logic
                    this.form.model.courseMatchLogic = ruleset.match_logic || ruleset.matchLogic || 'and';
                    // Transform conditions back to courseRequirements for the UI
                    if (ruleset.conditions && ruleset.conditions.length > 0) {
                        this.loadCoursesForExistingRequirements(ruleset.conditions);
                    }
                }
            });
        }
        else {
            // No existing rulesets, initialize empty
            this.form.model.enableSkillProficiencyRule = false;
            this.form.model.skillRequirements = [];
            this.form.model.skillMatchLogic = 'and';

            this.form.model.enableCourseCompletionRule = false;
            this.form.model.courseRequirements = [];
            this.form.model.courseMatchLogic = 'and';
        }

        if (!this.canUseSkillProficiencyRule) {
            this.form.model.enableSkillProficiencyRule = false;
            this.form.model.skillRequirements = [];
            this.form.model.skillMatchLogic = 'and';
        }
    }

    loadCoursesForExistingRequirements (courseConditions) {
        const courseIds = courseConditions.map(c => c.course_id || c.courseId).filter(Boolean);
        if (courseIds.length === 0) {
            return;
        }

        this.CourseResource.query({
            expand: 'activeI18n',
            'id[]': courseIds,
            pageSize: courseIds.length,
            includeArchived: true
        }).$promise.then(response => {
            const courses = response.items || response || [];
            courseConditions.forEach(condition => {
                const courseId = condition.course_id || condition.courseId;
                const course = courses.find(c => c.id === courseId) || condition.course || {};
                const label = (course.activeI18n && course.activeI18n.name)
                    || course.title || course.name || '';
                this.form.model.courseRequirements.push({ id: courseId, label });
            });
            this.updateCourseMultiselectModel();
        });
    }

    loadSkillsForExistingRequirements (skillConditions) {
        // Load all skills to get names
        this.SkillResource.query({
            expand: 'i18ns,scale.scaleI18ns,scale.proficiencies.skillProficiencyI18n',
            is_active: 1,
            pageSize: 0
        }).$promise.then(response => {
            const allSkills = response.items || response || [];

            // Filter proficiency i18ns by enabled scale languages
            allSkills.forEach(skill => {
                this.filterProficiencyI18nsByEnabledLanguages(skill);
            });

            // Transform each skill condition back to UI format
            skillConditions.forEach(condition => {
                const skill = allSkills.find(s => s.id === (condition.skill_id || condition.skillId));
                if (skill && skill.scale && skill.scale.proficiencies) {
                    const proficiency = skill.scale.proficiencies.find(
                        p => p.id === (condition.proficiency_id || condition.proficiencyId)
                    );

                    if (proficiency) {
                        this.form.model.skillRequirements.push({
                            skillId: skill.id,
                            skillName: this.getSkillName(skill),
                            operator: condition.comparison_operator || condition.comparisonOperator || '=',
                            proficiencyId: proficiency.id,
                            proficiencyName: this.getProficiencyValue(proficiency, skill),
                            proficiencyPoints: proficiency.points
                        });
                    }
                }
            });
        });
    }

    transformSkillRequirementsToTargetRulesets () {
        // Only transform if we have skill requirements and the feature is enabled
        if (!this.form.model.enableSkillProficiencyRule
            || !this.form.model.skillRequirements
            || this.form.model.skillRequirements.length === 0) {
            this.form.model.targetRulesets = (this.form.model.targetRulesets || [])
                .filter(r => r.rulesetType !== 'skill_proficiency');
            return;
        }

        // Transform skillRequirements array into targetRulesets structure
        const ruleset = {
            id: null, // Will be set by backend if updating existing
            rulesetType: 'skill_proficiency',
            matchLogic: this.form.model.skillMatchLogic || 'and',
            isActive: 1, // Must be integer: 1 for true, 0 for false
            conditions: this.form.model.skillRequirements.map(requirement => ({
                skillId: requirement.skillId,
                comparisonOperator: requirement.operator,
                proficiencyId: requirement.proficiencyId
            }))
        };

        this.form.model.targetRulesets = (this.form.model.targetRulesets || [])
            .filter(r => r.rulesetType !== 'skill_proficiency');
        this.form.model.targetRulesets.push(ruleset);
    }

    transformCourseRequirementsToTargetRulesets () {
        // If the enable flag was never set (undefined), preserve existing rulesets as-is.
        // after a save triggered from the target list (e.g. removeTarget).
        if (this.form.model.enableCourseCompletionRule === undefined) {
            return;
        }

        // Only transform if we have course requirements and the feature is enabled
        if (!this.form.model.enableCourseCompletionRule
            || !this.form.model.courseRequirements
            || this.form.model.courseRequirements.length === 0) {
            this.form.model.targetRulesets = (this.form.model.targetRulesets || [])
                .filter(r => r.rulesetType !== 'course_completion');
            return;
        }

        // Transform courseRequirements array into targetRulesets structure
        const ruleset = {
            id: null, // Will be set by backend if updating existing
            rulesetType: 'course_completion',
            matchLogic: this.form.model.courseMatchLogic || 'and',
            isActive: 1, // Must be integer: 1 for true, 0 for false
            conditions: this.form.model.courseRequirements.map(requirement => ({
                courseId: requirement.id
            }))
        };

        this.form.model.targetRulesets = (this.form.model.targetRulesets || [])
            .filter(r => r.rulesetType !== 'course_completion');
        this.form.model.targetRulesets.push(ruleset);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/edit/occurrence/automated/planningGroup/steps/targets/index.js